import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

export type StatusBarIconStyle = 'light' | 'dark';

export interface NativeStatusBarOptions {
  /** Light = white status-bar icons (for dark backgrounds). Dark = dark icons (for light backgrounds). */
  iconStyle?: StatusBarIconStyle;
  /** Android only — iOS status bar background is not programmatically settable. */
  backgroundColor?: string;
}

/**
 * Apply native status bar appearance. Safe to call from any shell; no-ops on web.
 * Failures are swallowed — Capacitor logs UNIMPLEMENTED when calling Android-only
 * APIs on iOS, so callers must not invoke setBackgroundColor outside Android.
 */
export async function applyNativeStatusBar(options: NativeStatusBarOptions): Promise<void> {
  if (!Capacitor.isNativePlatform() || !Capacitor.isPluginAvailable('StatusBar')) {
    return;
  }

  if (options.iconStyle) {
    try {
      // Capacitor Style names describe the *background* context, not the icon color:
      // Style.Dark = light icons (for dark backgrounds), Style.Light = dark icons.
      await StatusBar.setStyle({
        style: options.iconStyle === 'light' ? Style.Dark : Style.Light,
      });
    } catch {
      // Plugin unavailable or platform limitation — ignore silently.
    }
  }

  if (options.backgroundColor && Capacitor.getPlatform() === 'android') {
    try {
      await StatusBar.setBackgroundColor({ color: options.backgroundColor });
    } catch {
      // ignore
    }
  }
}
